export default "__VITE_PUBLIC_ASSET__01b3ab60__"